/**
 * @desc fulfilment
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.OutPlanFulfilmentRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/outPlan/fulfilment`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
